import {FAILED_AUTH_INDEX} from '@web-catalog/const/numbers';

import {useActiveCategory} from '@web-catalog/hooks/useActiveCategory';

import {useAuthorizedProfile} from '@web-catalog/store/auth';

import {logTmrEvent} from '@web-catalog/utils/analytics';

import {YmLogger} from './YmLogger';

type Props = {
  appCategoryName?: string;
};

// ToDo:
//  (step 1): объединить с useMenuAnalytics - > useSearchAnalytics
// (step 2): Зависимости передавать в логирующие методы (избаиться от функции обертки)
export const useLayoutAnalytics = () => {
  const activeCategory = useActiveCategory();
  const appCategoryName = activeCategory?.category || '';
  const userInfo = useAuthorizedProfile();

  const logAppsTopClick = () => {
    logTmrEvent({
      logEvent: 'appsTop.click',
      params: {
        app_category_name: appCategoryName,
        vk_id: userInfo?.id ?? FAILED_AUTH_INDEX,
      },
    });

    YmLogger.logAppsClick();
  };

  const logGamesTopClick = () => {
    logTmrEvent({
      logEvent: 'gamesTop.click',
      params: {
        app_category_name: appCategoryName,
        vk_id: userInfo?.id ?? FAILED_AUTH_INDEX,
      },
    });

    YmLogger.logGamesClick();
  };

  const logDevTopClick = () => {
    logTmrEvent({
      logEvent: 'devTop.click',
      params: {
        app_category_name: appCategoryName,
        vk_id: userInfo?.id ?? FAILED_AUTH_INDEX,
      },
    });

    YmLogger.logDevClick();
  };

  const logSupportTopClick = () => {
    logTmrEvent({
      logEvent: 'supportTop.click',
      params: {
        app_category_name: appCategoryName,
        vk_id: userInfo?.id ?? FAILED_AUTH_INDEX,
      },
    });

    YmLogger.logSupportClick();
  };

  const logDownloadRustoreTopClick = () => {
    logTmrEvent({
      logEvent: 'downloadRustoreTop.click',
      params: {
        app_category_name: appCategoryName,
        vk_id: userInfo?.id ?? FAILED_AUTH_INDEX,
      },
    });

    YmLogger.logDownloadRustoreClick();
  };

  return {
    logAppsTopClick,
    logGamesTopClick,
    logDevTopClick,
    logSupportTopClick,
    logDownloadRustoreTopClick,
  };
};
